export default {
  channel: null,
  requestId: 0,
  isLoading: false,
  isLoaded: false,
  data: [],
};
